module.exports = __webpack_public_path__ + "img/GSB.251fc066.png";